import { render, staticRenderFns } from "./CreateAndModify.vue?vue&type=template&id=bd0ef064&scoped=true"
import script from "./CreateAndModify.vue?vue&type=script&lang=js"
export * from "./CreateAndModify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0ef064",
  null
  
)

export default component.exports